import { Link } from "react-router-dom";
import { categories, siteContact } from "@/mocks/clueData";

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                17
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">17.cc</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-7 text-foreground-600">
              {siteContact.intro}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-base text-primary-600"></i>
              {siteContact.email}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li>
                <Link className="text-foreground-600 hover:text-primary-700" to="/">
                  网站首页
                </Link>
              </li>
              <li>
                <Link className="text-foreground-600 hover:text-primary-700" to="/clues">
                  热门爆料
                </Link>
              </li>
              <li>
                <Link className="text-foreground-600 hover:text-primary-700" to="/categories">
                  主题分类
                </Link>
              </li>
              <li>
                <Link className="text-foreground-600 hover:text-primary-700" to="/submit">
                  投稿爆料
                </Link>
              </li>
              <li>
                <Link className="text-foreground-600 hover:text-primary-700" to="/about">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">内容分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    className="text-foreground-600 hover:text-primary-700"
                    to={`/clues?category=${cat.id}`}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-950">投稿与合作</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-lightbulb-line text-base text-accent-600"></i>
                线索征集
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-shield-check-line text-base text-secondary-600"></i>
                隐私优先保护
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-send-plane-line text-base text-primary-600"></i>
                {siteContact.cooperateEmail}
              </li>
            </ul>
            <Link
              to="/submit"
              className="mt-4 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              立即投稿
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/60 pt-6 text-sm text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 17.cc 网友爆料站 · 内容来自网友投稿，仅供信息交流</p>
          <p className="whitespace-nowrap">请理性阅读，尊重隐私，抵制不实信息</p>
        </div>
      </div>
    </footer>
  );
}